export default __webpack_public_path__ + "static/media/dealercards_reavel.47a5e52c.mp3";